import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

import Login from './views/Login.vue';
import Publications from './views/Publications.vue';
import ProdelecPosts from './views/ProdelecPost.vue';
import Orders from './views/Orders.vue';
import Questions from './views/Questions.vue';
import Messages from './views/Messages.vue';
import Products from './views/Products.vue';
import Quotations from './views/Quotations.vue';
import ProductCategories from './views/ProductCategories.vue';
import ProductApplications from './views/ProductApplications.vue';
import ProductBrands from './views/ProductBrands.vue';
import ProductSectors from './views/ProductSectors.vue';
import Surtido from './views/Surtido.vue';
import Promos from './views/Promos.vue';
import Locations from './views/Locations.vue';
import BlogPosts from './views/BlogPosts.vue';
import WebInventory from './views/WebInventory.vue'
import FeedbackInvoices from './views/FeedbackInvoices.vue';
import FeedbackInvoicesPDV from './views/FeedbackInvoicesPDV.vue'
import BannerHome from './modals/BannerHomeModal.vue';
import _ from 'lodash';
import Catalogs from './views/Catalogs.vue';
import BoxScore from './views/BoxScore.vue';
import Ecommerce from './views/ecommerce.vue';
import ChatbotDocument from './views/chatbotDocuments.vue';
import Pdv from './views/Pdv.vue';

Vue.use(Router);

const router = new Router({
    linkActiveClass: 'active',
    routes: [
        { path: '*', redirect: '/products' },
        {
            path: '/web-inventory',
            name: 'web-inventory',
            component: WebInventory,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager', 'Inventory', 'Iluminacion', 'Practicante', 'gerente_pdv'],
            }
        },
        {
            path: '/chatbot-documents',
            name: 'chatbot-documents',
            component: ChatbotDocument,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager', 'Practicante'],
            },
        },

        {
            path: '/box-score',
            name: 'box-score',
            component: BoxScore,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager', 'Inventory'],
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                roles: [],
            },
        },
        {
            path: '/theme',
            name: 'theme',
            component: () => import('@/views/Theme.vue'),
            meta: {
                roles: ['Developer'],
            },
        },
        {
            path: '/logs',
            name: 'logs',
            component: () => import('@/views/Logs.vue'),
            meta: {
                roles: ['Admin', 'Developer'],
            },
        },
        {
            path: '/publications',
            name: 'publications',
            component: Publications,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager'],
            },
        },
        {
            path: '/products',
            name: 'products',
            component: Products,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager', 'Shop Manager', 'Iluminacion', 'Inventory', 'Practicante'],
            },
        },
        {
            path: '/quotations',
            name: 'quotations',
            component: Quotations,
            meta: {
                roles: ['Admin', 'Developer'],
            },
        },
        {
            path: '/orders',
            name: 'orders',
            component: Orders,
            meta: {
                roles: ['Admin', 'Developer'],
            },
        },
        {
            path: '/questions',
            name: 'questions',
            component: Questions,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager'],
            },
        },
        {
            path: '/messages',
            name: 'messages',
            component: Messages,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager'],
            },
        },
        {
            path: '/product-categories',
            name: 'product-categories',
            component: ProductCategories,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager', 'Inventory', 'Practicante', 'Shop Manager'],
            },
        },
        {
            path: '/product-applications',
            name: 'product-applications',
            component: ProductApplications,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager', 'Inventory'],
            },
        },
        {
            path: '/product-brands',
            name: 'product-brands',
            component: ProductBrands,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager', 'Inventory', 'Practicante'],
            },
        },
        {
            path: '/product-sectors',
            name: 'product-sectors',
            component: ProductSectors,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager', 'Inventory'],
            },
        },
        // {
        //     path: '/surtido',
        //     name: 'surtido',
        //     component: Surtido,
        //     meta: {
        //         roles: ['Admin', 'Developer', 'Surtido'],
        //     },
        // },
        {
            path: '/promotions',
            name: 'promotions',
            component: Promos,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager'],
            },
        },
        {
            path: '/pdv',
            name: 'pdv',
            component: Pdv,
            meta: {
                roles: ['Admin', 'Developer', 'Cajero', 'gerente_pdv'],
            },
        },
        {
            path: '/locations',
            name: 'locations',
            component: Locations,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager'],
            },
        },
        {
            path: '/banner-home',
            name: 'banner-home',
            component: BannerHome,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager'],
            },
        },
        {
            path: '/ecommerce',
            name: 'ecommerce',
            component: Ecommerce,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager'],
            },
        },
        {
            path: '/blog-posts',
            name: 'blog-posts',
            component: BlogPosts,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager'],
            },
        },
        {
            path: '/catalogs',
            name: 'catalogs',
            component: Catalogs,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager', 'Inventory'],
            },
        },
        {
            path: '/feedback-invoices',
            name: 'feedback-invoices',
            component: FeedbackInvoices,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager'],
            },
        },
        {
            path: '/feedback-invoices-pdv',
            name: 'feedback-invoices-pdv',
            component: FeedbackInvoicesPDV,
            meta: {
                roles: ['Admin', 'Developer', 'MercadoLibre Manager','Iluminacion', 'gerente_pdv'],
            },
        }
    ],
});

router.beforeEach(async (to, from, next) => {
    //
    let state: any = store.state;
    let jwt = localStorage.getItem(process.env.VUE_APP_DIRECTUS_ACCESS_TOKEN);
    let currentUser = state.auth.currentUser;

    if (currentUser == null) {
        store.dispatch('auth/login', { vm: null, payload: null });
        // console.log({currentUser})
        await sleep(3000);
        currentUser = state.auth.currentUser;
    }

    // console.log('router',{currentUser});

    if (jwt == null) {
        // public views

        if (to.matched.some(route => route.meta.roles.length == 0)) {
            console.log('Unsigned user going to open view');
            next();
        } else {
            console.log('Unsigned user trying to access auth based content');
            next('login');
        }
    } else {
        // auth views

        if (to.matched.some(route => route.name == 'login')) {
            console.log('Signed user trying to go to login');
            next('products');
        }

        if (
            to.matched.some(route => {
                console.log(route.name, `roles: ${route.meta.roles.length}`);
                return route.meta.roles.length == 0;
            })
        ) {
            console.log('Signed user going to open view');
            next();
        }

        if (currentUser) {
            if (to.matched.some(route => _.intersection(route.meta.roles, [currentUser.role.name]).length == 0)) {
                console.log('Signed user trying to access unauthorized view');
                next('products');
            } else {
                console.log('Signed user goint to authorized view');
                next();
            }
        }
    }
});

export const sleep = ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

export default router;
